import { Generation } from '../../../../shared/types'
import { IFamilyNode } from 'relatives-tree/lib/types'

export const enum SubFamilyType {
  SilkeSchuetz = 'SilkeSchuetz',
  GerlindDerdar = 'GerlindDerdar',
  MargitBronkalla = 'MargitBronkalla',
  RobertFriessleben = 'RobertFriessleben',
  AnkeMueller = 'AnkeMueller',
  ClaudiaPrange = 'ClaudiaPrange',
  TassiloLudwig = 'TassiloLudwig',
  RameshKuther = 'RameshKuther',
  CosimaKuther = 'CosimaKuther',
  MaikaVerbeek = 'MaikaVerbeek',
  DirkMichael = 'DirkMichael',
  RonaldMichael = 'RonaldMichael',
  RoyMichael = 'RoyMichael',
}

export const enum FamilyType {
  Root = 'Root',
  ThomasKuther = 'ThomasKuther',
  JuergenKuther = 'JuergenKuther',
  HeinzMichael = 'HeinzMichael',
  AndreasKuther = 'AndreasKuther',
  HeikeKuther = 'HeikeKuther',
  IlseKaiser = 'IlseKaiser',
}

export const enum RelType {
  blood = 'blood',
  married = 'married',
  adopted = 'adopted',
  half = 'half',
  partnership = 'partnership',
}

export interface FamilyNode extends IFamilyNode {
  family?: FamilyType | null
  subFamily?: SubFamilyType | null
  lastname?: string
  firstname?: string
  generation?: Generation
}

export type ExtNode = FamilyNode & {
  top: number
  left: number
  hasSubTree: boolean
}
